import React, { useEffect, useState } from "react";
import { supabase } from "../services/SupabaseClient";
import WorkshopCard from "./WorkshopCard";
import "./Workshop.css";

export default function WorkshopListItems() {
  const [workshops, setWorkshops] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWorkshops = async () => {
      const { data, error } = await supabase
        .from("workshop")
        .select("*")
        .order("date", { ascending: false });

      if (!error) setWorkshops(data);
      setLoading(false);
    };

    fetchWorkshops();
  }, []);

  if (loading) {
    return <p className="workshop-loading">Loading workshops…</p>;
  }

  return (
    <section className="workshop-section">
      <div className="workshop-header">
        <h2>Workshops & Training</h2>
        <p>Professional workshops, seminars, and hands-on training sessions.</p>
      </div>

      <div className="workshop-grid">
        {workshops.map((workshop) => (
          <WorkshopCard key={workshop.id} {...workshop} />
        ))}
      </div>
    </section>
  );
}
